/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import primaryComponents from "../../../../../../components/primaryComponents";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { PlusIcon } from "../../../../../../assets/svgIcons";
import { useAllPOCategories } from "./useAllPOCategories";
import {
  POCategoriesForm,
  POCategoriesTable,
} from "../../../../../../components/secondaryComponents/POCategories";
import { RoutedModal } from "../../../../../../components/common";

export const AllPOCategories = () => {
  const {
    search,
    isLoadingPOCat,
    metaDetails,
    isCreatePO,
    pOCategories,
    setIsCreatePO,
    filterBySearch,
    gotoPage,
  } = useAllPOCategories();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | PO Categories"
      description="View of all purchase order categories"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Procurement Categories</h4>
            <p>Create and manage your purchase order categories</p>
          </div>

          <div className={globalStyles.pageHeaders}>
            <p>{metaDetails?.total} Categories</p>

            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
            >
              <primaryComponents.Button
                classNames={"btn btn--primary ml-auto"}
                onClick={() => setIsCreatePO(true)}
              >
                <PlusIcon className="mr-1" /> Add Category
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>

          {/* table section */}
          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                classNames={`${globalStyles.searchField}`}
                placeholder="Search by PO category name"
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") || ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />
            </div>

            {/* table section */}
            <secondaryComponents.LoaderHelper
              isLoading={isLoadingPOCat}
              classNames="mt-5"
            >
              <POCategoriesTable
                pOCategories={pOCategories}
                metaDetails={metaDetails}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>
        </motion.div>

        <RoutedModal
          isActive={isCreatePO}
          closeModal={() => setIsCreatePO(false)}
          width={550}
          headerTitle="Create Procurement Category"
          style={{ height: "auto" }}
        >
          <POCategoriesForm closeModal={() => setIsCreatePO(false)} />
        </RoutedModal>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
